import { render, staticRenderFns } from "./SortBySelector.vue?vue&type=template&id=152c2983&scoped=true"
import script from "./SortBySelector.vue?vue&type=script&lang=js"
export * from "./SortBySelector.vue?vue&type=script&lang=js"
import style0 from "./SortBySelector.vue?vue&type=style&index=0&id=152c2983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c2983",
  null
  
)

export default component.exports